import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import useLoader from "../../../context/loaderContext/useLoader";
import { Loader } from "../loader/Loader";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(100% - 32px, 360px)",
  outline: "none",
};

export function LoaderModal() {
  const { isLoaderOpen: isOpen } = useLoader();

  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(7, 22, 56, 0.28)",
            backdropFilter: "blur(6px)",
          },
        },
      }}
    >
      <Box sx={style}>
        <Loader />
      </Box>
    </Modal>
  );
}
